import { Component, Input } from "@angular/core";
import { GameType } from "@apiserver-rest/ponder-data-client-base";
import { ExternalCollectionType } from "@apiserver-rest/ponder-tasks-client-base";

@Component({
    selector: "import-collection-note",
    imports: [],
    templateUrl: "./import-collection-note.component.html"
})
export class ImportCollectionMagicCsvNoteComponent {
    @Input() game?: GameType;
    @Input() format?: ExternalCollectionType;
    
    public gameTypes = GameType;
    public collectionFormats = ExternalCollectionType;

    public constructor() {

    }

    public ngOnInit(): void {

    }

    public ngOnChanges(): void {

    }
}